import cvEng from '../assets/pdf/MyResumeEngUpdated.pdf'
import cvEsp from '../assets/pdf/MyResumeEsp.pdf'
import me from "../utils/images/me.png"

export const headerData = {
    name: 'Guillermo Ojeda',
    title: "Full Stack Developer",
    description:`"When it looks impossible, look deeper and fight like you can win"`,
    image: me,
    resumePdfEng: cvEng,
    resumePdfEsp: cvEsp
}
